import React, { memo, useCallback } from 'react';
import Slider from 'react-rangeslider';
import 'react-rangeslider/lib/index.css';
import './styles.css';
import { cn } from '@wwe-portal/ui/lib/lib';
interface RangeSliderProps {
  min?: number;
  max?: number;
  value?: number;
  className?: string;
  onRangeSliderChange: (value: number) => void;
}

const RangeSlider: React.FC<RangeSliderProps> = ({
  min = 0,
  max = 10,
  value = 8,
  className,
  onRangeSliderChange,
}) => {
  /**
   * On Handle change range value
   * @param value {number}
   */
  const handleChange = useCallback(
    (val: number) => {
      return onRangeSliderChange(val);
    },
    [onRangeSliderChange]
  );

  return (
    <div
      className={cn('flex h-full max-w-[400px] items-center', className)}
      data-id={`range_slider_${value}`}
    >
      <Slider
        min={min}
        max={max}
        tooltip={false}
        className="m-0 h-2 w-9/12 min-w-[75%] max-w-[75%] flex-grow bg-['#00baff'] shadow-none"
        value={value}
        onChange={handleChange}
      />
      <div className="text-textColor2 ml-[15px] text-sm font-medium">
        {value} / {max}
      </div>
    </div>
  );
};

export default memo(RangeSlider);
